import { render } from "./TrendsChart.vue?vue&type=template&id=06f9925c"
import script from "./TrendsChart.vue?vue&type=script&lang=js"
export * from "./TrendsChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__